export default "__VITE_ASSET__Dfm0pC4v__"